import { StyledIllustrationFade, StyledIllustrationWrapper, StyledTaxonomyPill } from "./styles";

/**
 * Sample taxonomy paths, deliberately untranslated — the app renders industry names as they come from the backend,
 * and these are decorative rather than copy. Offsets and sizes come straight from the design.
 */
const TAXONOMY_PILLS = [
    {
        path: "Technology / Search and Information Discovery / General web search",
        fontSize: 7.91,
        left: 9.9,
        top: 17.3,
    },
    {
        path: "Retail & Consumer Products / Home Improvement / Building Materials and Lumber",
        fontSize: 10.4,
        left: 23.4,
        top: 50,
    },
    {
        path: "Chemical & Materials / General Chemical Manufacturing / Polymers Resins and Adhesives",
        fontSize: 6.96,
        left: 7.7,
        top: 89.2,
    },
    {
        path: "Personal & Household Services / Personal Care / Hair Care Services",
        fontSize: 8.82,
        left: 45.9,
        top: 116.6,
    },
] as const;

type IndustryTaxonomyBannerIllustrationProps = {
    /** Owned by the banner rendering it, so each banner keeps a single automation prefix. */
    readonly dataAutomation: string;
};

export const IndustryTaxonomyBannerIllustration = ({ dataAutomation }: IndustryTaxonomyBannerIllustrationProps) => {
    return (
        <StyledIllustrationWrapper
            aria-hidden="true"
            data-automation={dataAutomation}
        >
            {TAXONOMY_PILLS.map(({ path, fontSize, left, top }) => (
                <StyledTaxonomyPill
                    key={path}
                    $fontSize={fontSize}
                    $left={left}
                    $top={top}
                >
                    {path}
                </StyledTaxonomyPill>
            ))}

            <StyledIllustrationFade />
        </StyledIllustrationWrapper>
    );
};
